import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class HolidayService {


  async getHolidays(body) {
    try {
      const params = qs.stringify({
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
      });

      const response = await HttpClient.get(`/api/holiday/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addHolidays(body) {
    try {
      const response = await HttpClient.post(`/api/holiday/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

}

export default new HolidayService();

